var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFusdtz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_19248)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.36881L13.818 0.738281L27.0345 8.36881V23.6299L13.818 31.2604L0.601562 23.6299V8.36881Z",
    stroke: "url(#paint0_linear_2070_19248)",
    strokeWidth: 1.45455
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2070_19248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 2.87109L25.1864 9.43473V22.562L13.8178 29.1256L2.44922 22.562V9.43473L13.8178 2.87109Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2070_19248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 29.818C21.4498 29.818 27.6364 23.6314 27.6364 15.9998C27.6364 8.36825 21.4498 2.18164 13.8182 2.18164C6.18661 2.18164 0 8.36825 0 15.9998C0 23.6314 6.18661 29.818 13.8182 29.818Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6579 28.3158C20.3725 28.3158 25.8158 22.8725 25.8158 16.1579C25.8158 9.44327 20.3725 4 13.6579 4C6.94327 4 1.5 9.44327 1.5 16.1579C1.5 22.8725 6.94327 28.3158 13.6579 28.3158Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.63 12.8965H2.68648C2.19516 12.8965 1.79688 13.2948 1.79688 13.7861V18.3231C1.79688 18.8144 2.19516 19.2127 2.68648 19.2127H24.63C25.1213 19.2127 25.5196 18.8144 25.5196 18.3231V13.7861C25.5196 13.2948 25.1213 12.8965 24.63 12.8965Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6573 24.6114C18.3248 24.6114 22.1085 20.8277 22.1085 16.1602C22.1085 11.4927 18.3248 7.70898 13.6573 7.70898C8.9898 7.70898 5.20605 11.4927 5.20605 16.1602C5.20605 20.8277 8.9898 24.6114 13.6573 24.6114Z",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 1.46342
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.658 26.5367C19.39 26.5367 24.0367 21.8899 24.0367 16.158C24.0367 10.426 19.39 5.7793 13.658 5.7793C7.92599 5.7793 3.2793 10.426 3.2793 16.158C3.2793 21.8899 7.92599 26.5367 13.658 26.5367Z",
    stroke: "#F2F2F2",
    strokeWidth: 0.585366
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81073 19.1998C2.2373 19.1164 1.79688 18.6227 1.79688 18.0262V14.0822C1.79688 13.4639 2.26994 12.9561 2.87387 12.901C4.27122 8.26943 8.5707 4.89648 13.658 4.89648C18.7452 4.89648 23.0447 8.26941 24.4421 12.901C25.0463 12.9558 25.5196 13.4637 25.5196 14.0822V18.0262C25.5196 18.6229 25.0789 19.1167 24.5052 19.1999C23.1784 23.9428 18.8244 27.4215 13.658 27.4215C8.4915 27.4215 4.13755 23.9428 2.81073 19.1998ZM3.7296 19.2122C5.03353 23.4574 8.98535 26.5435 13.658 26.5435C18.3306 26.5435 22.2824 23.4574 23.5864 19.2122H3.7296ZM23.5195 12.8961C22.1515 8.75937 18.2533 5.77453 13.658 5.77453C9.06266 5.77453 5.16449 8.75937 3.79649 12.8961H23.5195Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8936 10.0059H14.4233V11.6462C15.5376 11.7915 16.7618 12.303 16.7618 13.3559V14.405H15.2999V13.8375C15.2999 13.3043 14.612 12.9431 13.7692 12.9431C12.9437 12.9431 12.2213 13.2871 12.2213 13.9923C12.2213 14.8178 13.1844 15.1618 14.2336 15.5229L14.4545 15.5973C15.7376 16.0352 17.1058 16.6259 17.1058 18.1544C17.1058 19.5718 15.9904 20.4442 14.4233 20.6627V22.3109H12.8936V20.6696C11.5265 20.4905 10.209 19.8056 10.209 18.636V17.7073H11.6709V18.2748C11.6709 19.0143 12.7029 19.3583 13.666 19.3583C14.6463 19.3583 15.4203 18.9627 15.4203 18.2404C15.4203 17.4237 14.5853 17.1288 13.4983 16.745L13.4981 16.7449C13.4178 16.7165 13.3361 16.6877 13.2532 16.6581L12.965 16.549C11.7596 16.0844 10.5358 15.4745 10.5358 14.0094C10.5358 12.6119 11.6601 11.8957 12.8936 11.6764V10.0059Z",
    fill: "black",
    fillOpacity: 0.67
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2070_19248",
    x1: -9.31078,
    y1: 15.9994,
    x2: 30.3386,
    y2: 15.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184658,
    stopColor: "#39E4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C7BCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_19248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6364,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusdtz);
export default __webpack_public_path__ + "static/media/fusdtz.bb7d23e71f005aad60fe91b23af63900.svg";
export { ForwardRef as ReactComponent };